<h3 class="title configurator-title">{{ 'closet-doors-custom.accessories.title' | translate }}</h3>

<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    <span>{{ 'closet-doors-custom.accessories.door-available-accessories' | translate }}</span>
  </h4>
  <ng-casto-loader *ngIf="!accessoryCategories"></ng-casto-loader>
  <div class="collapse-block" *ngIf="subStep === 1 && accessoryCategories">
    <ng-container *ngFor="let category of accessoryCategories">
      <h4 class="title configurator-subtitle">{{ category.name }}</h4>

      <ng-casto-quotation-disabled-products-alert
        [configuration]="configuration"></ng-casto-quotation-disabled-products-alert>

      <div class="accessory-container">
        <div
          class="accessory-card"
          *ngFor="let accessory of category.accessories"
          (click)="selectAccessory(accessory, category)"
          [ngClass]="{
            active: isAccessorySelected(accessory.id),
            disabled: accessory.isDisabled,
          }">
          <ng-casto-img-loader
            [imgSrc]="baseImgURL + accessory.icon.path"
            [imgClass]="'accessory-img'"></ng-casto-img-loader>
          <p class="accessory-title">
            {{ accessory.name }}
            <a *ngIf="accessory.toolTip" class="casto-tooltip" [tooltip]="accessory?.toolTip?.descriptionFr">?</a>
          </p>
        </div>
      </div>
    </ng-container>
    <div *ngIf="accessoryCategories.length === 0">
      <p class="text-muted">Aucun accessoire n'est disponible.</p>
    </div>
  </div>
</div>
